import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"
import { Theme } from "~/components/Theme/Theme"

import styles from "./index.module.css"

export const Contacts: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Theme className={styles.Wrapper} theme="dark">
      <div className="container grid grid--col-12">
        <div className={styles.ColLeft}>
          <Heading as="div" className={styles.Title} like="h1">
            <Raw html={t("stock.Contacts.Title")} />
          </Heading>
          <Link href="https://www.aoreestr.ru/" target="_blank" view="arrow">
            <Raw html={t("stock.Contacts.Link")} />
          </Link>
        </div>

        <div className={styles.ColRight}>
          <div className={styles.Contact}>
            <Raw html={t("stock.Contacts.Contact")} />
          </div>
          <div className={styles.Contact}>
            <a href="tel:84956170101">8 (495) 617-01-01</a>
          </div>
          <div className={styles.Contact}>
            <a href="mailto:reestr@aoreestr.ru">reestr@aoreestr.ru</a>
          </div>
        </div>
      </div>
    </Theme>
  )
}
